import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Singleton } from '../../../js/Singleton';
import { logoKolobAgent, poweredNuxiba } from '../../../Images/Images'
import { SingletonSharedData } from '../../../js/singletonSharedData';

export class About extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    this.state = {
      phonesSchedulesTags: [],
      pais: ""
    }
  }

  UNSAFE_componentWillMount() {
    this.getTagsByCountry();
  }

  componentDidMount() {
    if (this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
      const container = document.getElementById("custom-logo-about");
      container.innerHTML = this.props.customLogo;
    }
  }

  getTagsByCountry() {
    let arrayTags = this.state.phonesSchedulesTags;
    let pais = this.sharedData.getCountry();
    switch (pais) {
      case '1':
        arrayTags.push({
          phoneNumber: this.language.getText("GUIAboutphoneNumberMexico"),
          ePhoneNumber: this.language.getText("GUIAboutphoneNumberMexico2"),
          schedule: this.language.getText("GUIAboutscheduleMexico1"),
          schedule2: this.language.getText("GUIAboutscheduleMexico2"),
          schedule3: this.language.getText("GUIAboutscheduleMexico3"),
          eSchedule: this.language.getText("GUIAboutemergencyScheduleMexico"),
          eSchedule2: this.language.getText("GUIAboutemergencyScheduleMexico2"),
          showLastTags: true
        })
        break;
      case '2':
        arrayTags.push({
          phoneNumber: this.language.getText("GUIAboutphoneNumberSouthAmerica"),
          schedule: this.language.getText("GUIAboutscheduleLatinAmerica"),
          ePhoneNumber: this.language.getText("GUIAboutemergencyPhoneNumberSouthAmerica"),
          eSchedule: this.language.getText("GUIAboutemergencyScheduleLatinAmerica"),
          eSchedule2: this.language.getText("GUIAboutemergencyScheduleLatinAmerica2"),
          showLastTags: false
        })
        break;
      case '4':
        arrayTags.push({
          phoneNumber: this.language.getText("GUIAboutphoneNumberUsa"),
          schedule: this.language.getText("GUIAboutscheduleUsa"),
          ePhoneNumber: this.language.getText("GUIAboutemergencyPhoneNumberUsa"),
          eSchedule: this.language.getText("GUIAboutemergencyScheduleUsa"),
          eSchedule2: this.language.getText("GUIAboutemergencyScheduleUsa2"),
          showLastTags: false
        }
        )
        break;
      case '5':
        arrayTags.push({
          phoneNumber: this.language.getText("GUIAboutNumberSouthAmerica"),
          schedule: this.language.getText("GUIAboutscheduleLatinAmerica"),
          ePhoneNumber: this.language.getText("GUIAboutemergencySouthAmerica"),
          eSchedule: this.language.getText("GUIAboutemergencyScheduleLatinAmerica"),
          eSchedule2: this.language.getText("GUIAboutemergencyScheduleLatinAmerica2"),
          showLastTags: false
        }
        )
        break;
      default:
        arrayTags.push(
          {
            phoneNumber: this.language.getText("GUIAboutphoneNumberMexico"),
            ePhoneNumber: this.language.getText("GUIAboutphoneNumberMexico2"),
            schedule: this.language.getText("GUIAboutscheduleMexico1"),
            schedule2: this.language.getText("GUIAboutscheduleMexico2"),
            schedule3: this.language.getText("GUIAboutscheduleMexico3"),
            eSchedule: this.language.getText("GUIAboutemergencyScheduleMexico"),
            eSchedule2: this.language.getText("GUIAboutemergencyScheduleMexico2"),
            showLastTags: true
          }
        )
        break;
    }
    this.setState({ phonesSchedulesTags: arrayTags, pais: this.sharedData.getCountry() });
  }

  render() {
    return (
      <div className="aboutContainer">
        <div className="aboutHeader">
          <p className="titleHeaderAbout">{this.language.getText("GUIAboutabout")}</p>
          <div className="minimizeAbout" onClick={() => this.props.closeAboutWindow()}></div>
        </div>
        <div className="aboutBody">
          <div className="centerwareInfo">
            {
              this.props.whiteLabelEnabled ?
                <div id='custom-logo-about'>{this.props.customLogoFormat === 'image' && <img id='custom-about-img' alt='' src={this.props.customLogo} />}</div>
                :
                <img className="logo" alt='' src={logoKolobAgent}></img>
            }
            <p className="version">{this.language.getText("GUIAboutversion") + " " + this.sharedData.getVersionAgent()}</p>
            <p className="mail">{this.language.getText("GUIAboutsupport") + " " + this.language.getText("GUIAboutnuxibaMail")}</p>
          </div>
          <div className="contactInfo">
            <div className="containerInfo">

              <h1>{this.language.getText("GUIAboutscheduleOpening")}</h1>
              <h2>{this.language.getText("GUIAboutmondayToFriday")}</h2>
              <p>{this.state.phonesSchedulesTags[0].schedule}<br /> {this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber}</p>
              {this.state.phonesSchedulesTags[0].showLastTags &&
                <div>
                  <h2>{this.language.getText("GUIAboutsaturday")}</h2>
                  <p>{this.state.phonesSchedulesTags[0].schedule2}<br /> {this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber}</p>
                  <h2>{this.language.getText("GUIAboutsunday")}</h2>
                  <p>{this.state.phonesSchedulesTags[0].schedule3}<br /> {this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].phoneNumber}</p>
                </div>
              }
            </div>
            <div className="containerInfo">
              <h1>{this.language.getText("GUIAboutemergencies")}</h1>
              <h2>{this.language.getText("GUIAboutmondayToFriday")}</h2>
              <p>{this.state.phonesSchedulesTags[0].eSchedule}<br /> {this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].ePhoneNumber}</p>
              <h2>{this.language.getText("GUIAboutsaturdayAndMonday")}</h2>
              <p>{this.state.phonesSchedulesTags[0].eSchedule2}<br /> {this.language.getText("GUIAboutphone") + " " + this.state.phonesSchedulesTags[0].ePhoneNumber}</p>
            </div>

            <img className="logo" alt='' src={poweredNuxiba}></img>

          </div>
        </div>
        <div className="aboutFooter">
          {this.language.getText("GUILogingalateaCopyright")}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
  customLogo: state.whiteLabelState.about,
  customLogoFormat: state.whiteLabelState.imageFormat
})

export default connect(mapStateToProps)(About)


// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/About.jsx